module.exports = __webpack_public_path__ + "assets/img/typeIcon-4-red.3815063c.svg";